import * as React from 'react'
import { BaseOverviewCount, BaseOverviewHeaderItemProps } from '../../../pages/BaseOverview/BaseOverview'
import BaseOverviewCountBadge from '../../../pages/BaseOverview/BaseOverviewCountBadge'
import { NoteOverviewDto } from '../../../config/noteConfig'
import { NoteFilterType, NoteSortingType } from './BaseNoteOverview'

/**
 * The header row of the note overview: only the count. There are no columns to label - a note is a title with
 * a description, not a row of fields - and the order is fixed, so there is nothing to sort on either.
 */
export default function NoteHeaderItem(props: BaseOverviewHeaderItemProps<NoteOverviewDto, NoteFilterType, NoteSortingType, BaseOverviewCount>) {
    return (
        <>
            <BaseOverviewCountBadge {...props} />
            <div></div>
        </>
    )
}
